export default "__VITE_ASSET__7d9d0a1f__"